import type {
  Address,
  Contact,
  CreditAccount,
  ClientServiceProfile as InitialClientServiceProfile,
  CreditPackageDetail,
  ClientCreditAccountsQuery,
  CreditAccountTransactionsByFiltersQuery,
} from "@/__generated__/graphql";
import type { ElderCareFormData } from "@/containers/profile/service-profile/service-profile-form/elder/useElderCareForm";

export enum ChangePhoneNumberModalEnum {
  CHANGE_PHONE_NUMBER = "changePhoneNumber",
  CHANGE_PHONE_NUMBER_OTP_VERIFICATION = "changePhoneNumberVerification",
  CANCEL_CHANGE_PHONE_NUMBER = "cancelChangePhoneNumber",
  CHANGE_PHONE_NUMBER_SUCCESS = "changePhoneNumberSuccess",
}

export type ClientCreditAccount = Omit<CreditAccount, "__typename">;

export type ClientAddresses = Omit<Address, "__typename" | "client">;

export type ClientContacts = Omit<Contact, "__typename" | "client">;

export type ClientServiceProfile = Omit<
  InitialClientServiceProfile,
  "__typename" | "client" | "profileAttributes"
> & {
  profileAttributes: ElderCareFormData;
};

export type CreditAccountType =
  | "general"
  | "massage"
  | "overview"
  | "beauty"
  | "pet";

export type CreditPackageData = Omit<
  CreditPackageDetail,
  "__typename" | "department" | "topUpRewards" | "code" | "businessCentralCode"
> & {
  department?: {
    id: string;
    name: string;
  } | null;
};

export type ClientCreditAccounts =
  ClientCreditAccountsQuery["client"]["creditAccounts"];

export type ClientCreditAccountTransactions =
  CreditAccountTransactionsByFiltersQuery["creditAccountTransactionsByFilters"]["creditAccountTransactions"];

export type ClientCreditAccountTransaction =
  ClientCreditAccountTransactions[number];

export interface CreateAddressProps {
  createAddressLoading: boolean;
  onSubmit: () => void;
}

export interface UpdateAddressProps {
  onSubmit: () => void;
  updateAddressLoading: boolean;
  showTooltip: boolean;
}

export interface CreateContactProps {
  createContactLoading: boolean;
  onSubmit: () => void;
}

export interface UpdateContactProps {
  onSubmit: () => void;
  updateContactLoading: boolean;
  showTooltip: boolean;
}
